import React from 'react'
import { createRoot } from 'react-dom/client'
import { CapformEdit } from "./../capform/Edit";
import { WidgetEdit } from "./../widget/Edit";
import ProofIndex from "./../proof/Index";
import ProofNew from "./../proof/New";
import ProofEdit from "./../proof/Edit";
import ProofManage from "./../proof/Manage";
import WallHandPicked from "./../wall/HandPicked";
import SurveyEdit from "./../survey/Edit";
import WallEdit from "./../wall/Edit";
//import { VideoEdit } from "./../VideoEdit";
//import { VideoNew } from "./../VideoNew";
 
// used for rendering the composition in the live app
//registerRoot(RemotionRoot);

const attachReact = (el, cb) => {
  const node = document.getElementById(el)
  if (node) { cb(node) }
}

document.addEventListener('turbo:load', () => {
  attachReact('react-capform-edit', function (node) {
    const root = createRoot(node)
    root.render(<CapformEdit {...JSON.parse(node.getAttribute('data')) } />)
  })
  attachReact('react-proof-index', function (node) {
    const root = createRoot(node)
    root.render(<ProofIndex {...JSON.parse(node.getAttribute('data')) } />)
  })
  attachReact('react-proofs-new', function (node) {
    const root = createRoot(node)
    root.render(<ProofNew {...JSON.parse(node.getAttribute('data')) } />)
  })
  attachReact('react-proofs-edit', function (node) {
    const root = createRoot(node)
    root.render(<ProofEdit {...JSON.parse(node.getAttribute('data')) } />)
  })
  attachReact('react-proofs-manage', function (node) {
    const root = createRoot(node)
    root.render(<ProofManage {...JSON.parse(node.getAttribute('data')) } />)
  })
  attachReact('react-widget-edit', function (node) {
    const root = createRoot(node)
    root.render(<WidgetEdit {...JSON.parse(node.getAttribute('data')) } />)
  })
  attachReact('react-wall-hand-picked', function (node) {
    const root = createRoot(node)
    root.render(<WallHandPicked {...JSON.parse(node.getAttribute('data')) } />)
  })
  attachReact('react-surveys-edit', function (node) {
    const root = createRoot(node)
    root.render(<SurveyEdit {...JSON.parse(node.getAttribute('data')) } />)
  })
  attachReact('react-walls-edit', function (node) {
    const root = createRoot(node)
    root.render(<WallEdit {...JSON.parse(node.getAttribute('data')) } />)
  })
  //attachReact('react-video-form', function (node) {
    //const root = createRoot(node)
    //root.render(<VideoEdit {...JSON.parse(node.getAttribute('data')) } />)
  //})
  //attachReact('react-video-new', function (node) {
    //const root = createRoot(node)
    //console.log('loading react-video-new from turbo:load')
    //root.render(<VideoNew {...JSON.parse(node.getAttribute('data')) } />)
  //})
})
